/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List material functions
 */

export const listMaterialFunctionsQueryPerPageMax = 100;

export const listMaterialFunctionsQueryStateDefault = `ACTIVE`;
export const listMaterialFunctionsQuerySortKeyDefault = `materialFunctionId`;

export const ListMaterialFunctionsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listMaterialFunctionsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe("Case-insensitive substring search across Material Function code or name"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listMaterialFunctionsQueryStateDefault)
    .describe("Material Function state filter"),
  sortKey: zod
    .enum(["materialFunctionId", "code", "name"])
    .default(listMaterialFunctionsQuerySortKeyDefault)
    .describe("Material Function sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listMaterialFunctionsResponseMetaTotalMin = 0;

export const ListMaterialFunctionsResponse = zod.object({
  items: zod.array(
    zod.object({
      materialFunctionId: zod.uuid().describe("Material Function identity."),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      code: zod.string(),
      name: zod.string(),
      description: zod.string(),
    }),
  ),
  meta: zod
    .object({
      total: zod
        .int()
        .min(listMaterialFunctionsResponseMetaTotalMin)
        .describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create material function
 */
export const CreateMaterialFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const CreateMaterialFunctionResponse = zod.uuid().describe("Material Function identity.");

/**
 * @summary Get material function
 */
export const getMaterialFunctionQueryIncludeDeletedDefault = false;

export const GetMaterialFunctionQueryParams = zod.object({
  includeDeleted: zod.coerce.boolean().default(getMaterialFunctionQueryIncludeDeletedDefault),
});

export const GetMaterialFunctionResponse = zod.object({
  materialFunctionId: zod.uuid().describe("Material Function identity."),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

/**
 * @summary Update material function
 */
export const UpdateMaterialFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const UpdateMaterialFunctionResponse = zod.void();

/**
 * @summary Delete material function
 */
export const DeleteMaterialFunctionResponse = zod.void();

/**
 * @summary Restore material function
 */
export const RestoreMaterialFunctionResponse = zod.void();
